// import React, { Component } from 'react';
// import Cookies from 'universal-cookie';
// import '../CSS/assets-minified/all-demo.css'
// import '../CSS/assets-minified/css/bootstrap.min.css'
// import Header from '../components/dashboardSubComponents/header'
// import SideBar from '../components/dashboardSubComponents/sideBarNav'
// import { Loader } from 'react-overlay-loader';
// import { url,logout, media_url } from '../components/helper'
// import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
// import Calendar from 'react-calendar';
// import Fade from 'react-reveal/Fade';
// // import { Calendar } from 'react-native-calendars';
// // import {loadingGIF} from '../CSS/assets-minified/giphy_loading.gif'
// import ResponseTable from '../components/responseListSubComponenets/responseTable'

// class QuestionResponseList extends Component{

//     constructor(props){
//         super(props)
//         this.state = {

//             total_records:10,
//             responses:[],
//             loading: true,
//             tableLoading:false,
//             activePage:1,
//             page_size:20,
//             section:0,
//             search_param:"",
//             search_info_hidden:true,
//             local_search_message:"",
//             resultMessage:"",
//             response_backup:[],
//             SelectDateModalOpen:false,
//             FromDate : new Date(),
//             ToDate : new Date(),
//             messageBoxOpen:false,
//             messageTitle:"",
//             messageBody:"",
//             fileProcessing:false,
//         }
//         this.handlePageSizeChange.bind(this)
//         this.fetch_with_page_size.bind(this)
//         this.toggleTableLoader.bind(this)
//         this.next_page.bind(this)
//         this.search.bind(this)
//         this.handleSearchFieldChange = this.handleSearchFieldChange.bind(this)
//         this.tableSearch = this.tableSearch.bind(this)
//         this.resultsMessageHack = this.resultsMessageHack.bind(this)
//         this.refreshAfterSearch = this.refreshAfterSearch.bind(this)
//         this.handleEnterPressOnSearch = this.handleEnterPressOnSearch.bind(this)
//         this.HandleFromDateSelect = this.HandleFromDateSelect.bind(this)
//         this.openSelectDateModal = this.openSelectDateModal.bind(this)
//         this.HandleToDateSelect = this.HandleToDateSelect.bind(this)
//         this.triggerFileDownload = this.triggerFileDownload.bind(this)
//         this.downloadFile = this.downloadFile.bind(this)
//     }

//     componentWillMount = () =>{
//     const cookies = new Cookies();
//     var loginStatus = cookies.get('loggedIn')
//     if (loginStatus === undefined) {
//         window.location = "/login"
//     }
//     var http = new XMLHttpRequest()
//     var dashboar_ref = this
//     var user_id = cookies.get('user_id')
//     var token = cookies.get('token')
//     http.open('GET', url+'/api/questions/responses?user_id='+user_id, true);
//     http.setRequestHeader("Authorization", "Token "+token);
//     http.onreadystatechange = function(){
//         if(http.readyState === 4 && http.status === 200){
//             var json = JSON.parse(http.responseText)
//             //(http.responseText)
//             if(json.status === 200){
//                 if(json.question_responses.length !==0){
//                     dashboar_ref.setState({
//                         responses:json.question_responses,
//                         response_backup:json.question_responses,
//                         total_records:json.total_responses,
//                         section:1
//                     })
//                 }
//                 else{
//                     dashboar_ref.setState({
//                         section:2
//                     })
//                 }
//             }
//             else{
//                 dashboar_ref.setState({
//                     section:2
//                 })
//             }
//         }
//         if(http.readyState === 4 && http.status === 401){
//             logout()
//         }

//     }
//     http.onerror =  function(){
//         dashboar_ref.setState({
//             section:2
//         })
//     }
//     http.ontimeout = function(){
//         dashboar_ref.setState({
//             section:2
//         })
//     }
//     //("sending")
//     http.send()
//     }

//     resultsMessageHack = () =>{
//         this.setState({resultMessage:"showing results for : "+this.state.search_param})
//     }

//     fetch_with_page_size = (pageSize) =>{
//         const cookies = new Cookies();
//         this.setState({tableLoading:true})
//         var http = new XMLHttpRequest()
//         var dashboar_ref = this
//         var user_id = cookies.get('user_id')
//         var token = cookies.get('token')
//         if(this.state.search_param !== ""){
//             //("search param present")

//             http.open('GET', url+'/api/questions/responses?user_id='+user_id+'&page='+1+'&page_size='+pageSize+"&q="+this.state.search_param, true);
//         }
//         else{
//             http.open('GET', url+'/api/questions/responses?user_id='+user_id+'&page='+1+'&page_size='+pageSize, true);
//         }

//         http.setRequestHeader("Authorization", "Token "+token);
//         http.onreadystatechange = function(){
//             if(http.readyState === 4 && http.status === 200){
//                 var json = JSON.parse(http.responseText)
//                 if(json.status === 200){
//                     if(json.question_responses.length !==0){
//                         dashboar_ref.setState({
//                             responses:json.question_responses,
//                             response_backup:json.question_responses,
//                             total_records:json.total_responses,
//                             tableLoading:false,
//                             activePage:1,
//                             section:1
//                         })
//                     }
//                     else{
//                         dashboar_ref.setState({
//                             tableLoading:false,
//                             section:2
//                         })
//                     }
//                 }
//                 else{
//                     dashboar_ref.setState({
//                         section:2
//                     })
//                 }
//             }
//             http.onerror =  function(){
//                 dashboar_ref.setState({
//                     section:2
//                 })
//             }
//             http.ontimeout = function(){
//                 dashboar_ref.setState({
//                     section:2
//                 })
//             }
//         }
//         http.send()
//     }

//     next_page = (page) =>{
//         const cookies = new Cookies();
//         this.setState({tableLoading:true})
//         var http = new XMLHttpRequest()
//         var dashboar_ref = this
//         var user_id = cookies.get('user_id')
//         var token = cookies.get('token')

//         if(this.state.search_param !== ""){
//             http.open('GET', url+'/api/questions/responses?user_id='+user_id+'&page='+page+'&page_size='+this.state.page_size+"&q="+this.state.search_param, true);
//         }
//         else{

//             http.open('GET', url+'/api/questions/responses?user_id='+user_id+'&page='+page+'&page_size='+this.state.page_size, true);
//         }
//         http.setRequestHeader("Authorization", "Token "+token);
//         http.onreadystatechange = function(){
//             if(http.readyState === 4 && http.status === 200){
//                 var json = JSON.parse(http.responseText)
//                 if(json.status === 200){
//                     if(json.question_responses !== 0){
//                         dashboar_ref.setState({
//                             responses:json.question_responses,
//                             response_backup:json.question_responses,
//                             total_records:json.total_responses,
//                             tableLoading:false,
//                             activePage:page,
//                             section:1,
//                         })
//                     }
//                     else{
//                         dashboar_ref.setState({
//                             tableLoading:false,
//                             section:2,
//                         })
//                     }
//                 }
//                 else{
//                     dashboar_ref.setState({
//                         section:2
//                     })
//                 }
//             }
//             http.onerror =  function(){
//                 dashboar_ref.setState({
//                     section:2
//                 })
//             }
//             http.ontimeout = function(){
//                 dashboar_ref.setState({
//                     section:2
//                 })
//             }
//         }
//         http.send()
//     }

//     refreshAfterSearch = () =>{
//         const cookies = new Cookies();
//         this.setState({tableLoading:true})
//         var http = new XMLHttpRequest()
//         var dashboar_ref = this
//         var user_id = cookies.get('user_id')
//         var token = cookies.get('token')

//         http.open('GET', url+'/api/questions/responses?user_id='+user_id+'&page='+1+'&page_size='+this.state.page_size, true);
//         http.setRequestHeader("Authorization", "Token "+token);
//         http.onreadystatechange = function(){
//             if(http.readyState === 4 && http.status === 200){
//                 var json = JSON.parse(http.responseText)
//                 if(json.status === 200){
//                     if(json.question_responses !== 0){
//                         dashboar_ref.setState({
//                             responses:json.question_responses,
//                             response_backup:json.question_responses,
//                             total_records:json.total_responses,
//                             tableLoading:false,
//                             activePage:1,
//                             section:1,
//                             search_info_hidden:true
//                         })
//                     }
//                     else{
//                         dashboar_ref.setState({
//                             tableLoading:false,
//                             section:2,
//                         })
//                     }
//                 }
//                 else{
//                     dashboar_ref.setState({
//                         section:2
//                     })
//                 }
//             }
//             http.onerror =  function(){
//                 dashboar_ref.setState({
//                     section:2
//                 })
//             }
//             http.ontimeout = function(){
//                 dashboar_ref.setState({
//                     section:2
//                 })
//             }
//         }
//         http.send()
//     }

//     handlePageSizeChange = (pageSize) =>{

//             this.setState({page_size:pageSize},this.fetch_with_page_size(pageSize))
//             // this.setState({page_size:pageSize})

//     }

//     toggleTableLoader = () =>{
//         this.setState({
//             tableLoading:!this.state.tableLoading
//         })
//     }
//     handleSearchFieldChange = () =>{
//         var input = document.getElementById("search").value
//         if(input === ""){
//             this.refreshAfterSearch()
//         }
//         this.setState({
//             search_param:input
//         })
//         //(input)
//         //("voot zee fook")
//     }

//     handleEnterPressOnSearch = (e) =>{
//         if(e.key === 'Enter'){
//             this.search()
//         }
//     }
//     search = () =>{
//         const cookies = new Cookies();
//         this.setState({tableLoading:true})
//         var http = new XMLHttpRequest()
//         var dashboar_ref = this
//         var user_id = cookies.get('user_id')
//         var token = cookies.get('token')
//         http.open('GET', url+'/api/questions/responses?user_id='+user_id+'&page='+1+'&page_size='+this.state.page_size+"&q="+this.state.search_param, true);
//         http.setRequestHeader("Authorization", "Token "+token);
//         http.onreadystatechange = function(){
//             if(http.readyState === 4 && http.status === 200){
//                 var json = JSON.parse(http.responseText)
//                 if(json.status === 200){
//                     if(json.question_responses !== 0){
//                         dashboar_ref.resultsMessageHack()
//                         dashboar_ref.setState({
//                             responses:json.question_responses,
//                             response_backup:json.question_responses,
//                             total_records:json.total_responses,
//                             tableLoading:false,
//                             activePage:1,
//                             section:1,
//                             search_info_hidden:false
//                         })
//                     }
//                     else{
//                         dashboar_ref.resultsMessageHack()
//                         dashboar_ref.setState({
//                             tableLoading:false,
//                             section:2,
//                         })
//                     }
//                 }
//                 else{
//                     dashboar_ref.setState({
//                         section:2
//                     })
//                 }
//             }
//             http.onerror =  function(){
//                 dashboar_ref.setState({
//                     section:2
//                 })
//             }
//             http.ontimeout = function(){
//                 dashboar_ref.setState({
//                     section:2
//                 })
//             }
//         }
//         http.send()
//     }

//     tableSearch = () =>{
//         var input = document.getElementById("local_search").value
//         //("--->>"+input)
//         if(input === ""){
//             this.setState({
//                 responses:this.state.response_backup,
//                 local_search_message:""
//             })
//         }
//         else{
//             //searching
//             var result = this.state.response_backup.filter(element =>{
//                 return element.run_id.includes(input) === true || element.drop_id.includes(input) === true || element.question_section.includes(input) === true || element.question_text.includes(input) === true
//             })
//             if(result.length !== 0){
//                 this.setState({
//                     responses:result,
//                     local_search_message:result.length+" matches found"
//                 })
//             }
//             else{
//                 this.setState({
//                     local_search_message:result.length+" matches found"
//                 })
//             }
//             //("results")
//             //(result)
//         }

//     }

//     closeSelectDateModal = () =>{
//         this.setState({
//             SelectDateModalOpen:false
//         })
//     }

//     HandleFromDateSelect = (FromDate) =>{
//         this.setState({FromDate},function(){
//             //(this.state.FromDate)
//         })

//     }

//     HandleToDateSelect = (ToDate) =>{
//         //("got this")
//         //(ToDate)
//         this.setState({
//             ToDate
//         },function(){
//             //("after setting"); //(this.state.ToDate)
//         })
//     }

//     openSelectDateModal = () =>{
//         this.setState({
//             SelectDateModalOpen:true
//         })
//     }

//     triggerFileDownload = () => {
//         var elem = document.getElementById('file');
//         if(elem && document.createEvent) {
//            var evt = document.createEvent("MouseEvents");
//            evt.initEvent("click", true, false);
//            elem.dispatchEvent(evt);
//         }

//      }

//      downloadFile = () =>{
//          //("downloading for")
//          this.setState({
//             SelectDateModalOpen:false
//          })
//          var from = ""+this.state.FromDate.getFullYear()
//          from = this.state.FromDate.getMonth()+1 < 10 ? from+"-0"+(this.state.FromDate.getMonth()+1) : from+"-"+(this.state.FromDate.getMonth()+1)
//          from = this.state.FromDate.getDate() < 10 ? from+"-0"+this.state.FromDate.getDate() : from+"-"+(this.state.FromDate.getDate())
//          var to = ""+this.state.ToDate.getFullYear()
//          to = this.state.ToDate.getMonth()+1 < 10 ? to+"-0"+(this.state.ToDate.getMonth()+1) : to+"-"+(this.state.ToDate.getMonth()+1)
//          to = this.state.ToDate.getDate() < 10 ? to+"-0"+this.state.ToDate.getDate() : to+"-"+(this.state.ToDate.getDate())
//          //(from)
//          //(to)
//          const cookies = new Cookies();
//         var http = new XMLHttpRequest();
//         var dashboard_ref = this
//         var user_id = cookies.get('user_id')
//         var token = cookies.get('token')
//         dashboard_ref.setState({
//             fileProcessing:true
//         })
//         // document.getElementById("bod").className = "bodPro"

//         http.open('POST', url+'/api/questions/responses?user_id='+user_id, true);
//         http.setRequestHeader("Authorization", "Token " + token);
//         http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
//         http.send('&from=' + from+'&to='+to)
//         http.onreadystatechange = function(){
//             if(http.readyState === 4 && http.status === 200){
//                 var json = JSON.parse(http.responseText)
//                 // //(http.responseText)
//                 console.log(json)
//                 if(json.status === 200){
//                     document.getElementById("file").setAttribute("href",media_url+json.link)
//                     dashboard_ref.triggerFileDownload()
//                     // document.getElementById("bod").className = ""
//                     dashboard_ref.setState({
//                         fileProcessing:false
//                     })
//                 }
//                 if(json.status === 403){
//                     dashboard_ref.setState({
//                         SelectDateModalOpen:false,
//                         messageBoxOpen:true,
//                         messageTitle:"Response Limit Exceeded",
//                         messageBody:"Only 1 million records can be downloaded at a time.Try selecting different dates",
//                         fileProcessing:false
//                         })
//                 }
//                 if(json.status === 204){
//                     dashboard_ref.setState({
//                         SelectDateModalOpen:false,
//                         messageBoxOpen:true,
//                         messageTitle:"Response Record Download",
//                         messageBody:"There are no record. Try selecting different dates",
//                         fileProcessing:false
//                         })
//                 }
//             }
//         }

//      }

//      closeMessageBox = () =>{
//          this.setState({
//              messageBoxOpen:false
//          })
//      }

//     render(){
//        if(this.state.section === 0){
//             return(
//                 <Loader loading={true} fullPage={true} />
//             )
//        }
//        if(this.state.section === 1){
//         return(
//             <div >
//                 <div className="clearfix"  id="page-header">
//                         <div>
//                            <Header />
//                            </div>
//                     </div>

//                     <div >
//                         <SideBar isActive="response"/>
//                     </div>
//                     <div id="page-content-wrapper" className="rm-transition">
//                     <div id="page-content" >

//                     <div class="modalDownloading" hidden={!this.state.fileProcessing}>
//                     <p className="processingText">Preparing File For Download...</p>
//                     </div>

//                     <Modal isOpen={this.state.messageBoxOpen}>
//                         <ModalHeader>{this.state.messageTitle}</ModalHeader>
//                         <ModalBody>
//                             <b>{this.state.messageBody}</b>
//                         </ModalBody>
//                         <ModalFooter>

//                             <Button onClick={this.closeMessageBox}>Close</Button>
//                         </ModalFooter>
//                     </Modal>
//                     <Modal size="lg" isOpen={this.state.SelectDateModalOpen}>
//                         <ModalHeader>
//                             Download Response Record
//                         </ModalHeader>
//                         <ModalBody>
//                             <div className="row" >

//                                 <div className="container">
//                                 <div className="col-md-6">
//                                 <h4>From:</h4>
//                                 <Calendar
//                                     onChange={this.HandleFromDateSelect}
//                                     value={this.state.FromDate}
//                                     nextLabel="Next Month"
//                                     prevLabel="Previous Month"
//                                     maxDate = {new Date()}

//                                     />
//                                 </div>
//                                 <div className="col-md-6">
//                                 <h4>To:</h4>
//                                 <Calendar
//                                     style={{height:1000}}
//                                     onChange={this.HandleToDateSelect}
//                                     value={this.state.ToDate}
//                                     nextLabel="Next Month"
//                                     prevLabel="Previous Month"
//                                     maxDate = {new Date()}

//                                     />
//                                 </div>

//                                 </div>
//                                     </div>

//                             {/* <div className="row" >
//                                 <div className="container">

//                                     </div>
//                             </div> */}
//                         </ModalBody>
//                         <ModalFooter>
//                             <Button onClick={this.closeSelectDateModal}>Cancel</Button>
//                             <Button color="primary" onClick={this.downloadFile}>Download</Button>
//                         </ModalFooter>
//                     </Modal>
//                     <div className="row">
//                     <div className="col-md-12">
//                     <h2 style={{textAlign:"center"}}>Question Responses</h2>
//                     </div>
//                     </div>
//                     <div className="row">
//                         <div className="container">
//                         {/* <div className="input-group input-group-lg">
//                         <input type="text" id="search" placeholder="Search responses here..." className="form-control" value={this.state.search_param} onChange={this.handleSearchFieldChange} onKeyPress={this.handleEnterPressOnSearch} class="form-control"></input>
//                         <i class="glyph-icon icon-search passviewicon"></i>
//                         <i class="fas fa-download passviewicon" onClick={this.openSelectDateModal} title="Dowmload Response Record"></i>
//                         <div class="input-group-btn">

//                             <button type="button" class="btn btn-default" tabindex="-1" onClick={this.search}>
//                                 <i class="glyph-icon icon-search passviewicon"></i>
//                             </button>

//                         </div>
//                     </div> */}
//                     <div className="form-group">
//                         <div className="input-group input-group-lg">
//                         <input type="text" id="search" placeholder="Search responses here..." className="form-control" value={this.state.search_param} onChange={this.handleSearchFieldChange} onKeyPress={this.handleEnterPressOnSearch} class="form-control"></input>
//                         <i class="glyph-icon icon-search searchIcon"  onClick={this.search}></i>
//                         <i class="fas fa-download downloadIcon" onClick={this.openSelectDateModal} title="Dowmload Response Record"></i>
//                         <a href="" id="file" hidden="true">Down Test</a>
//                         </div>
//                     </div>

//                 <div className="row" style={{marginTop:100}}>
//                     <div className="container">
//                         <div className="row">
//                             <div className="col-md-4">
//                             <h5 hidden={this.state.search_info_hidden}>{this.state.resultMessage}</h5>
//                             </div>
//                             <div className="col-md-4"></div>
//                             <div className="col-md-4">
//                             <div >
//                             <label className="local_label" style={{float:"right", marginRight:35}}>{this.state.local_search_message}</label>
//                             </div>
//                             <div>
//                             <input type="text" id="local_search" placeholder="Filter Results..."  onChange={this.tableSearch}  class="form-control local_field" style={{float:"right", marginRight:35}}></input>
//                             </div>

//                             </div>
//                         </div>
//                         <Fade left>
//                         <ResponseTable data={this.state.responses} record={this.state.total_records} activePage={this.state.activePage} page_size={this.state.page_size} handlePageSizeChange={this.handlePageSizeChange} loading={this.state.tableLoading} toggleTableLoader={this.toggleTableLoader} fetch={this.next_page}/>
//                         </Fade>
//                     </div>
//                     </div>
//                         </div>
//                     </div>

//                     </div>
//                     </div>
//             </div>
//         )
//        }
//        if(this.state.section === 2){
//         return(
//             <div>
//                 <div className="clearfix"  id="page-header">
//                         <div>
//                            <Header />
//                            </div>
//                     </div>

//                     <div >
//                         <SideBar isActive="response"/>
//                     </div>
//                     <div id="page-content-wrapper" className="rm-transition">
//                     <div id="page-content">
//                     <div className="row">
//                     <div className="col-md-12">
//                     <h2 style={{textAlign:"center"}}>Question Responses</h2>
//                     </div>
//                     </div>
//                     <div className="row" style={{marginTop:100}}>
//                     <div className="container">
//                         <div className="row">
//                             <div className="col-md-4">

//                             </div>
//                             <div className="col-md-4">
//                             <h3 style={{textAlign:"center"}}>No Record Found</h3>
//                             </div>
//                             <div className="col-md-4">
//                             </div>
//                         </div>
//                     </div>
//                     </div>
//                     </div>
//                     </div>
//             </div>
//         )
//        }
//     }
// }

// export default QuestionResponseList;

import React, { Component } from 'react'
import Cookies from 'universal-cookie'
import '../CSS/assets-minified/all-demo.css'
import '../CSS/assets-minified/css/bootstrap.min.css'
import Header from '../components/dashboardSubComponents/header'
import SideBar from '../components/dashboardSubComponents/sideBarNav'
import { Loader } from 'react-overlay-loader'
import { url, logout, media_url } from '../components/helper'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import Calendar from 'react-calendar'
import Fade from 'react-reveal/Fade'
// import { Calendar } from 'react-native-calendars';
// import {loadingGIF} from '../CSS/assets-minified/giphy_loading.gif'
import ResponseTable from '../components/responseListSubComponenets/responseTable'

const QuestionResponseList = () => {
    const [totalRecords, setTotalRecords] = React.useState(10)
    const [responses, setResponses] = React.useState([])
    const [loading, setLoading] = React.useState(true)
    const [tableLoading, setTableLoading] = React.useState(false)
    const [activePage, setActivePage] = React.useState(1)
    const [pageSize, setPageSize] = React.useState(20)
    const [section, setSection] = React.useState(0)
    const [searchParam, setSearchParam] = React.useState('')
    const [searchInfoHidden, setSearchInfoHidden] = React.useState(true)
    const [localSearchMessage, setLocalSearchMessage] = React.useState('')
    const [resultMessage, setResultMessage] = React.useState('')
    const [responseBackup, setResponseBackup] = React.useState([]) //PFIX: What is this? Why is this needed (See getResponses() for more reason why not)
    const [selectDateModalOpen, setSelectDateModalOpen] = React.useState(false)
    const [fromDate, setFromDate] = React.useState(new Date())
    const [toDate, setToDate] = React.useState(new Date())
    const [messageBoxOpen, setMessageBoxOpen] = React.useState(false)
    const [messageTitle, setMessageTitle] = React.useState('')
    const [messageBody, setMessageBody] = React.useState('')
    const [fileProcessing, setFileProcessing] = React.useState(false)

    //Credential Check
    const credentialCheck = () => {
        const cookies = new Cookies()
        const loginStatus = cookies.get('loggedIn')
        if (!loginStatus) {
            window.location = '/login'
        }
    }

    //Get all the question responses
    const getResponses = async () => {
        const cookies = new Cookies()
        const userId = cookies.get('user_id')
        const token = cookies.get('token')

        const options = {
            method: 'GET',
            headers: {
                Authorization: `Token ${token}`,
            },
        }

        try {
            const res = await fetch(
                `${url}/api/questions/responses?user_id=${userId}`,
                options
            )
            const data = await res.json()

            switch (data.status) {
                case 200:
                    if (data.question_responses.length !== 0) {
                        setResponses(data.question_responses)
                        setResponseBackup(data.question_responses)
                        setTotalRecords(data.total_responses)
                        setSection(1)
                    } else {
                        setSection(2)
                    }
                    break
                case 401:
                    logout()
                default:
                    console.error('Invalid data', data)
                    setSection(2)
                    break
            }
        } catch (err) {
            console.error('Error', err)
            setSection(2)
        }
    }

    //Run once on the initial render
    React.useEffect(() => {
        credentialCheck()
        getResponses()
    }, [])

    //PFIX: What does this do?
    const resultsMessageHack = () => {
        setResultMessage(`Showing results for: ${searchParam}`)
    }

    const fetchWithPageSize = async (pageSize) => {
        setTableLoading(true)

        const cookies = new Cookies()
        const userId = cookies.get('user_id')
        const token = cookies.get('token')

        const options = {
            method: 'GET',
            headers: {
                Authorization: `Token ${token}`,
            },
        }

        let endpoint_url = `${url}/api/questions/responses?user_id=${userId}&page=1&page_size=${pageSize}`
        if (searchParam) {
            endpoint_url = `${url}/api/questions/responses?user_id=${userId}&page=1&page_size=${pageSize}&q=${searchParam}`
        }

        try {
            const res = await fetch(endpoint_url, options)
            const data = await res.json()

            switch (data.status) {
                case 200:
                    if (data.question_responses.length !== 0) {
                        setResponses(data.question_responses)
                        setResponseBackup(data.question_responses)
                        setTotalRecords(data.total_responses)
                        setTableLoading(false)
                        setActivePage(1)
                        setSection(1)
                    } else {
                        setSection(2)
                    }
                    break
                default:
                    console.error('Invalid data', data)
                    setSection(2)
                    break
            }
        } catch (err) {
            console.error('Error', err)
            setSection(2)
        }
    }

    const nextPage = async (page) => {
        setTableLoading(true)

        const cookies = new Cookies()
        const userId = cookies.get('user_id')
        const token = cookies.get('token')

        const options = {
            method: 'GET',
            headers: {
                Authorization: `Token ${token}`,
            },
        }

        let endpoint_url = `${url}/api/questions/responses?user_id=${userId}&page=${page}&page_size=${pageSize}`
        if (searchParam) {
            endpoint_url = `${url}/api/questions/responses?user_id=${userId}&page=${page}&page_size=${pageSize}&q=${searchParam}`
        }

        try {
            const res = await fetch(endpoint_url, options)
            const data = await res.json()

            switch (data.status) {
                case 200:
                    if (data.question_responses.length !== 0) {
                        setResponses(data.question_responses)
                        setResponseBackup(data.question_responses)
                        setTotalRecords(data.total_responses)
                        setTableLoading(false)
                        setActivePage(1)
                        setSection(1)
                    } else {
                        setSection(2)
                    }
                    break
                default:
                    console.error('Invalid data', data)
                    setSection(2)
                    break
            }
        } catch (err) {
            console.error('Error', err)
            setSection(2)
        }
    }

    const refreshAfterSearch = async () => {
        setTableLoading(true)

        const cookies = new Cookies()
        const userId = cookies.get('user_id')
        const token = cookies.get('token')

        const options = {
            method: 'GET',
            headers: {
                Authorization: `Token ${token}`,
            },
        }

        try {
            const res = await fetch(
                `${url}/api/questions/responses?user_id=${userId}&page=1&page_size=${pageSize}`,
                options
            )
            const data = await res.json()

            switch (data.status) {
                case 200:
                    if (data.question_responses.length !== 0) {
                        setResponses(data.question_responses)
                        setResponseBackup(data.question_responses)
                        setTotalRecords(data.total_responses)
                        setTableLoading(false)
                        setActivePage(1)
                        setSection(1)
                    } else {
                        setSection(2)
                    }
                    break
                default:
                    console.error('Invalid data', data)
                    setSection(2)
                    break
            }
        } catch (err) {
            console.error('Error', err)
            setSection(2)
        }
    }

    const handlePageSizeChange = (pageSize) => {
        setPageSize(pageSize)
        fetchWithPageSize(pageSize)
    }

    const toggleTableLoader = () => {
        setTableLoading(!tableLoading)
    }

    const handleSearchFieldChange = () => {
        const input = document.getElementById('search').value
        if (!input) {
            refreshAfterSearch()
        }
        setSearchParam(input)
    }

    const handleEnterPressOnSearch = (e) => {
        if (e.key === 'Enter') {
            search()
        }
    }

    const search = async () => {
        setTableLoading(true)

        const cookies = new Cookies()
        const userId = cookies.get('user_id')
        const token = cookies.get('token')

        const options = {
            method: 'GET',
            headers: {
                Authorization: `Token ${token}`,
            },
        }

        try {
            const res = await fetch(
                `${url}/api/questions/responses?user_id=${userId}&page=1&page_size=${pageSize}&q=${searchParam}`,
                options
            )
            const data = await res.json()

            switch (data.status) {
                case 200:
                    if (data.question_responses.length !== 0) {
                        resultsMessageHack() //PFIX: Its a hack, should be fixed
                        setResponses(data.question_responses)
                        setResponseBackup(data.question_responses)
                        setTotalRecords(data.total_responses)
                        setTableLoading(false)
                        setActivePage(1)
                        setSection(1)
                        setSearchInfoHidden(false)
                    } else {
                        resultsMessageHack()
                        setSection(2)
                    }
                    break
                default:
                    console.error('Invalid data', data)
                    setSection(2)
                    break
            }
        } catch (err) {
            console.error('Error', err)
            setSection(2)
        }
    }

    const tableSearch = () => {
        const input = document.getElementById('local_search').value
        if (!input) {
            setResponses(responseBackup)
            setLocalSearchMessage('')
        } else {
            const result = responseBackup.filter((rb) => {
                return (
                    rb.run_id.includes(input) ||
                    rb.drop_id.includes(input) ||
                    rb.question_section.includes(input) ||
                    rb.question_text.includes(input)
                )
            })
            if (result.length !== 0) {
                setResponses(result)
            }
            setLocalSearchMessage(`${result.length} matches found`)
        }
    }

    const closeSelectDateModal = () => {
        setSelectDateModalOpen(false)
    }

    const handleFromDateSelect = (toDate) => {
        setToDate(toDate)
    }
    const openSelectDateModal = () => {
        setSelectDateModalOpen(true)
    }
    const handleToDateSelect = () => {}
    const triggerFileDownload = () => {
        const elem = document.getElementById('file')
        if (elem) {
            const evt = document.createEvent('MouseEvents')
            evt.initEvent('click', true, false)
            elem.dispatchEvent(evt)
        }
    }
    const downloadFile = async () => {
        setSelectDateModalOpen(false)
        let from = `${fromDate.getFullYear()}`
        from =
            fromDate.getMonth() < 10
                ? `${from}-0${fromDate.getMonth() + 1}`
                : `${from}-${fromDate.getMonth() + 1}`
        from =
            fromDate.getDate() < 10
                ? `${from}-0${fromDate.getDate() + 1}`
                : `${from}-${fromDate.getDate() + 1}`

        let to = `${toDate.getFullYear()}`
        to =
            toDate.getMonth() < 10
                ? `${to}-0${toDate.getMonth() + 1}`
                : `${to}-${toDate.getMonth() + 1}`
        to =
            toDate.getDate() < 10
                ? `${to}-0${toDate.getDate() + 1}`
                : `${to}-${toDate.getDate() + 1}`

        setFileProcessing(true)

        const cookies = new Cookies()
        const userId = cookies.get('user_id')
        const token = cookies.get('token')

        const options = {
            method: 'POST',
            headers: {
                Authorization: `Token ${token}`,
                'Content-type': 'application/x-www-form-urlencoded',
            },
            body: `&from=${from}&to=${to}`,
        }

        try {
            const res = await fetch(
                `${url}/api/questions/responses?user_id=${userId}`,
                options
            )
            const data = await res.json()

            switch (data.status) {
                case 200:
                    document
                        .getElementById('file')
                        .setAttribute('href', `${media_url}${data.link}`)
                    triggerFileDownload()
                    setFileProcessing(false)
                    break
                case 403:
                    setSelectDateModalOpen(false)
                    setMessageBoxOpen(true)
                    setMessageTitle('Response Limit Exceeded')
                    setMessageBody(
                        'Only 1 million records can be downloaded at a time. Try selecting different dates'
                    )
                    setFileProcessing(false)
                    break
                case 204:
                    setSelectDateModalOpen(false)
                    setMessageBoxOpen(true)
                    setMessageTitle('Response Record Download')
                    setMessageBody(
                        'There are no record. Try selecting different dates'
                    )
                    setFileProcessing(false)
                    break
                default:
                    console.error('Invalid data', data)
                    break
            }
        } catch (err) {
            console.error('Error', err)
        }
    }

    const closeMessageBox = () => {
        setMessageBoxOpen(false)
    }

    return (
        <div>
            {section === 0 ? (
                <Loader loading={true} fullPage={true} />
            ) : (
                <div></div>
            )}
            {section === 1 ? (
                <div>
                    <div className="clearfix" id="page-header">
                        <div>
                            <Header />
                        </div>
                    </div>

                    <div>
                        <SideBar isActive="response" />
                    </div>
                    <div id="page-content-wrapper" className="rm-transition">
                        <div id="page-content">
                            <div
                                class="modalDownloading"
                                hidden={!fileProcessing}
                            >
                                <p className="processingText">
                                    Preparing File For Download...
                                </p>
                            </div>

                            <Modal isOpen={messageBoxOpen}>
                                <ModalHeader>{messageTitle}</ModalHeader>
                                <ModalBody>
                                    <b>{messageBody}</b>
                                </ModalBody>
                                <ModalFooter>
                                    <Button onClick={closeMessageBox}>
                                        Close
                                    </Button>
                                </ModalFooter>
                            </Modal>
                            <Modal size="lg" isOpen={selectDateModalOpen}>
                                <ModalHeader>
                                    Download Response Record
                                </ModalHeader>
                                <ModalBody>
                                    <div className="row">
                                        <div className="container">
                                            <div className="col-md-6">
                                                <h4>From:</h4>
                                                <Calendar
                                                    onChange={
                                                        this
                                                            .HandleFromDateSelect
                                                    }
                                                    value={fromDate}
                                                    nextLabel="Next Month"
                                                    prevLabel="Previous Month"
                                                    maxDate={new Date()}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <h4>To:</h4>
                                                <Calendar
                                                    style={{ height: 1000 }}
                                                    onChange={
                                                        this.HandleToDateSelect
                                                    }
                                                    value={toDate}
                                                    nextLabel="Next Month"
                                                    prevLabel="Previous Month"
                                                    maxDate={new Date()}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* <div className="row" >
                                 <div className="container">

                                     </div>
                             </div> */}
                                </ModalBody>
                                <ModalFooter>
                                    <Button onClick={closeSelectDateModal}>
                                        Cancel
                                    </Button>
                                    <Button
                                        color="primary"
                                        onClick={downloadFile}
                                    >
                                        Download
                                    </Button>
                                </ModalFooter>
                            </Modal>
                            <div className="row">
                                <div className="col-md-12">
                                    <h2 style={{ textAlign: 'center' }}>
                                        Question Responses
                                    </h2>
                                </div>
                            </div>
                            <div className="row">
                                <div className="container">
                                    <div className="form-group">
                                        <div className="input-group input-group-lg">
                                            <input
                                                type="text"
                                                id="search"
                                                placeholder="Search responses here..."
                                                className="form-control"
                                                value={searchParam}
                                                onChange={
                                                    handleSearchFieldChange
                                                }
                                                onKeyPress={
                                                    handleEnterPressOnSearch
                                                }
                                                class="form-control"
                                            ></input>
                                            <i
                                                class="glyph-icon icon-search searchIcon"
                                                onClick={search}
                                            ></i>
                                            <i
                                                class="fas fa-download downloadIcon"
                                                onClick={openSelectDateModal}
                                                title="Download Response Record"
                                            ></i>
                                            <a href="" id="file" hidden="true">
                                                Down Test
                                            </a>
                                        </div>
                                    </div>

                                    <div
                                        className="row"
                                        style={{ marginTop: 100 }}
                                    >
                                        <div className="container">
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <h5
                                                        hidden={
                                                            searchInfoHidden
                                                        }
                                                    >
                                                        {resultMessage}
                                                    </h5>
                                                </div>
                                                <div className="col-md-4"></div>
                                                <div className="col-md-4">
                                                    <div>
                                                        <label
                                                            className="local_label"
                                                            style={{
                                                                float: 'right',
                                                                marginRight: 35,
                                                            }}
                                                        >
                                                            {localSearchMessage}
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <input
                                                            type="text"
                                                            id="local_search"
                                                            placeholder="Filter Results..."
                                                            onChange={
                                                                tableSearch
                                                            }
                                                            class="form-control local_field"
                                                            style={{
                                                                float: 'right',
                                                                marginRight: 35,
                                                            }}
                                                        ></input>
                                                    </div>
                                                </div>
                                            </div>
                                            <Fade left>
                                                <ResponseTable
                                                    data={responses}
                                                    record={totalRecords}
                                                    activePage={activePage}
                                                    page_size={pageSize}
                                                    handlePageSizeChange={
                                                        handlePageSizeChange
                                                    }
                                                    loading={tableLoading}
                                                    toggleTableLoader={
                                                        toggleTableLoader
                                                    }
                                                    fetch={nextPage}
                                                />
                                            </Fade>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div></div>
            )}
            {section === 2 ? (
                <div>
                    <div className="clearfix" id="page-header">
                        <div>
                            <Header />
                        </div>
                    </div>

                    <div>
                        <SideBar isActive="response" />
                    </div>
                    <div id="page-content-wrapper" className="rm-transition">
                        <div id="page-content">
                            <div className="row">
                                <div className="col-md-12">
                                    <h2 style={{ textAlign: 'center' }}>
                                        Question Responses
                                    </h2>
                                </div>
                            </div>
                            <div className="row" style={{ marginTop: 100 }}>
                                <div className="container">
                                    <div className="row">
                                        <div className="col-md-4"></div>
                                        <div className="col-md-4">
                                            <h3 style={{ textAlign: 'center' }}>
                                                No Record Found
                                            </h3>
                                        </div>
                                        <div className="col-md-4"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div></div>
            )}
        </div>
    )
}

export default QuestionResponseList

/**
 * Notes
 * - NextPage(), fetchWithPageSize(), and getResponses(), refreshAfterSearch() are all very similar, refactor?
 */



// WEBPACK FOOTER //
// src/Routes/QuestionResponseList.js